import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider, Menu, MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import InvoiceSelect from "../../../components/form/InvoiceSelect";
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {CREATE_SALE_CREDIT_NOTE, CREATE_PURCHASE_CREDIT_NOTE} from "../../../constants/eInvoicePermissions";
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";

function CreditNoteListPageActions({ actions, isPurchase = false }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const createPermission = isPurchase ? CREATE_PURCHASE_CREDIT_NOTE : CREATE_SALE_CREDIT_NOTE;
  const canCreate = hasEInvoicePermission(createPermission);


  const handleMenuOpen = (event) => {
    if (!canCreate) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedInvoice(null);
  };

  const handleContinue = () => {
    if (selectedInvoice) {
      navigate(
        isPurchase
          ? "/purchases/credit-notes/create"
          : "/sales/credit-notes/create",
        {
          state: { source: 'invoice', invoiceData: selectedInvoice },
        },
      );
    }
  };
  const handleCreateCustomCreditNote = () => {
    if (!canCreate) {
      return;
    }
    handleMenuClose();
    navigate(isPurchase ? '/purchases/credit-notes/create' : '/sales/credit-notes/create');
  };
  return (
    <>
      {actions.map((createAction, index) => (
          <PermissionDeniedWrapper key={index} show={!canCreate} title={accessDeniedMessage}>
            <Button
              id="create-credit-note"
              key={index}
              variant="contained"
              color="primary"
              onClick={handleMenuOpen}
              disabled={!canCreate}
            >
              {isPurchase
                ? "+ Create self billed Credit Note"
                : "+ Create Credit Note"}
            </Button>
          </PermissionDeniedWrapper>
      ))}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem
            onClick={() => {
              handleMenuClose();
              setOpen(true);
            }}
        >
          {"Linked Credit Note"}
        </MenuItem>

        <MenuItem onClick={handleCreateCustomCreditNote}>{"Standalone Credit Note"}</MenuItem>
      </Menu>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Select Invoice</DialogTitle>
        <Divider />
        <DialogContent>
          Select an invoice from the dropdown to continue.
        </DialogContent>
        <DialogContent>
          <InvoiceSelect
            name="select-invoice"
            onSelect={setSelectedInvoice}
            isPurchase={isPurchase}
          />
        </DialogContent>
        <DialogActions>
          <Button
            id="credit-note-cancel"
            onClick={handleClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            id="credit-note-continue"
            onClick={handleContinue}
            variant="contained"
            disabled={!selectedInvoice}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CreditNoteListPageActions;
